import React, { useState } from 'react';
import RLCPanel from './RLCPanel'
import FreezeIcons from './FreezeIcons'
import { Alert, AlertTitle } from '@material-ui/lab';
import { withStyles } from '@material-ui/core/styles';
import { ExpandIcon, ErrorIcon, WarningIcon } from 'common/components/icons';
import { Accordion, Grid,Typography, AccordionSummary, AccordionDetails } from '@material-ui/core';
import { ActionButton } from 'common/components/CudaDialog'
import { ReloadIcon } from 'common/components/icons';

const styles = {
    typography: {
        display: "inline-block",
    },
    clusterTypography: {
        extend: 'typography',
        fontSize: "16px",
    },
    lbCountLabel: {
        extend: 'typography',
        paddingTop: '1.5px'
    },
    regionIdLabel: {
        extend: 'typography',
        paddingTop: '1.5px',
        paddingLeft: '5px',
    },
    warningIcon: {
        marginTop: '4px',
    },
    typographyError: {
        extend: 'clusterTypography',
        color: '#f44336'
    },
    typographyWarning: {
        extend: 'clusterTypography',
        color: '#f18e00'
    },
    accordionDetail: {
        marginTop: '-10px',
        paddingTop: '0px',
    },
};

const ClusterPanel = ({ classes, clusterId, clusterData, getDeviceinfo, devices_info, traffic_managers_info }) => {
    const [expanded, setExpanded] = useState(false)

    const renderError = (errorKey, error) => {
        switch(errorKey) {
            case 'unexpected_deployments':
                let unexpected_deps = error.join(', ')
                return <><strong>Unexpected deployments found:</strong> {unexpected_deps}<br/></>	
            case 'missing_deployments':
                let missing_deps = error.join(', ')
                return <><strong>Missing deployments:</strong> {missing_deps}<br/></>	
            case 'tm_expected_not_reported_more_than_5_mins':
                let missing_tms = error.join(', ')
                return <><strong>Missing traffic managers (more than 5 min):</strong>: {missing_tms}<br/></>
            default:
                return <><strong>General Error:</strong> Unexpected error received: <strong>{errorKey}</strong><br/></> 
        }
    }

    const renderWarning = (warningKey, warning) => {
        switch(warningKey) {
            case 'high_restart_count':
                return <>There are <strong>pods/containers</strong> with a <strong>high restart count</strong><br/></>	
            case 'unexpected_deployments_deleting':
                let unexpected_deps = warning.join(', ')
                return <><strong>Unexpected deployments found (deletion in progress):</strong>: {unexpected_deps}<br/></>	
            case 'missing_deployments_creating':
                let missing_deps = warning.join(', ')
                return <><strong>Missing deployments (creation in progress):</strong>: {missing_deps}<br/></>
            case 'tm_expected_not_reported_less_than_5_mins':
                let missing_tms = warning.join(', ')
                return <><strong>Missing traffic managers (less than 5 min):</strong>: {missing_tms}<br/></>
            case 'status_error':
                let con_stat_reason = warning['container_status_reason'] ? "<strong>Container Status Reason: </strong>{warning['container_status_reason']}, " : ""
                let con_status = warning['container'] ? "<strong>Container Status: </strong>{warning['container']}, " : ""
                return <><strong>Status Warning for pod</strong>: {warning['pod_name']} <strong>Pod Status: </strong>{warning['pod_status']}, {con_status}
                {con_stat_reason} <strong>Controller: </strong>{warning['controller_name']}</>
            default:
                return <><strong>General Warning</strong>: Unexpected warning received: {warningKey}<br/></>
        }
    }

    let errors = 'errors' in clusterData ? clusterData['errors'] : {}
    let warnings = 'warnings' in clusterData ? clusterData['warnings'] : {}
    let hasTM = traffic_managers_info && clusterId in traffic_managers_info && Object.keys(traffic_managers_info).length !== 0

    if (hasTM && traffic_managers_info[clusterId]['tm_expected_not_reported_more_than_5_mins'].length)
        errors['tm_expected_not_reported_more_than_5_mins'] = traffic_managers_info[clusterId]['tm_expected_not_reported_more_than_5_mins']
    
    if (hasTM &&traffic_managers_info[clusterId]['tm_expected_not_reported_less_than_5_mins'].length)
        warnings['tm_expected_not_reported_less_than_5_mins'] = traffic_managers_info[clusterId]['tm_expected_not_reported_less_than_5_mins']

    let clusterStatus = (Object.keys(errors).length !== 0) ? 'error' : (Object.keys(warnings).length !== 0) ? 'warning' : ''

    return <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
        <AccordionSummary
            expandIcon={<ExpandIcon />}
            aria-label="Expand"
            aria-controls="panel1a-content"
            id="panel1a-header"
        >
            <Grid container spacing={1} alignItems="center">
                <Grid item container xs={3} spacing={1} alignItems="center">
                    <Grid item className={classes.warningIcon}>
                        {clusterStatus === 'error' ? <ErrorIcon/> : clusterStatus === 'warning' ? <WarningIcon/> : "" }
                    </Grid>
                    <Grid item>
                        <Typography className={clusterStatus === 'error' ? classes.typographyError : clusterStatus === 'warning' ? classes.typographyWarning : classes.clusterTypography} variant='subtitle2'>{clusterData['name']}</Typography>
                        <Typography className={classes.regionIdLabel} variant='caption' color="textSecondary">({clusterId})</Typography>
                        <FreezeIcons current_fe_dict={clusterData['current_freeze_event']} past_fe_dict={clusterData['past_freeze_event']}/>
                    </Grid>
                </Grid> 
                <Grid item>
                    <ActionButton 
                        aria-label="refresh-ver" 
                        variant="contained" 
                        color="primary" 
                        size="small" 
                        startIcon={<ReloadIcon />}
                        onClick={(event) => {getDeviceinfo(); event.stopPropagation()}} 
                        onFocus={(event) => event.stopPropagation()}
                        >
                        Container Versions
                    </ActionButton>
                </Grid>
                <Grid container item xs spacing={1} justifyContent="flex-end" alignItems="flex-end">
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTP CPS: {clusterData['connections']['http_delta_connections']},</Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTPS CPS: {clusterData['connections']['https_delta_connections']},</Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTP RPS: {clusterData['connections']['http_delta_requests']},</Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTPS RPS: {clusterData['connections']['https_delta_requests']},</Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTP Conns: {clusterData['connections']['current_http_metric']},</Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTPS Conns:  {clusterData['connections']['current_https_metric']},</Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">{clusterData['node_count']} Nodes,</Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">{clusterData['pod_count']} Pods,</Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">{clusterData['app_count']} Apps,</Typography>
                    </Grid>                      
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">Deployments (reported/expected): {Object.keys(clusterData['existing_deployment']).length}/{Object.keys(clusterData['expected_deployment']).length}{hasTM && <>,</>}</Typography>
                    </Grid>
                    {hasTM &&
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">Traffic Managers (reported/expected): {traffic_managers_info[clusterId]['tm_reported']}/{traffic_managers_info[clusterId]['tm_expected']}</Typography>
                    </Grid>}
                </Grid>
            </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetail}>
            <Grid container>
                {/* Global errors */}
                {(Object.keys(errors).length !== 0) && 
                <Grid item xs={12}>
                    <Alert severity='error'>
                        <AlertTitle>Errors</AlertTitle>
                        {Object.keys(errors).map((e) => 			
                        <Grid item xs={12} key={e}>
                            {renderError(e, errors[e])}
                        </Grid>)}
                    </Alert>
                </Grid>
                }
                {/* Global warnings */}
                {(Object.keys(warnings).length !== 0) && 
                <Grid item xs={12}>
                    <Alert severity='warning'>
                        <AlertTitle>Warnings</AlertTitle>
                        {Object.keys(warnings).map((w) => 
                        <Grid item xs={12} key={w}>
                            {renderWarning(w, warnings[w])}
                        </Grid>)}
                    </Alert>
                </Grid>
                }
                {/* RLC panel */}
                {clusterData['RLCs'].map((r) =>
                    <Grid item xs={12} key={r['id']}>
                        <RLCPanel RLCId={r['id']} RLCData={r} devices_info={devices_info}/>
                    </Grid>
                )}
            </Grid>
        </AccordionDetails>
    </Accordion>
};

export default withStyles(styles)(ClusterPanel);